import ExperimentationSDK from '@component/experiment/src/js/ExperimentationSDK';
import KillSwitchUtil from './KillSwitchUtil';
import Util from './Util';

const checkForRecipe = (recipe, resolve) => {
  ExperimentationSDK.getSelectedRecipesForExperiment([recipe]).always((recipeIds) => {
    if (recipeIds && recipeIds.length) {
      resolve(true);
    } else {
      resolve(false);
    }
  });
};

const experimentEnabled = (killSwitch, recipe) => new Promise((resolve) => {
  if (KillSwitchUtil.isTrue(killSwitch)) {
    checkForRecipe(recipe, resolve);
  } else {
    resolve(false);
  }
});

const anyExperimentEnabled = (killSwitch, recipes) => new Promise((resolve) => {
  if (KillSwitchUtil.isTrue(killSwitch)) {
    ExperimentationSDK.getSelectedRecipesForExperiment(recipes).always((allRecipes) => {
      // this refers to promise scope, access statically prevent scoping issues
      if (allRecipes && allRecipes.length) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  } else {
    resolve(false);
  }
});

const FEATURE = {
  PROS_REDESIGN_TREATMENT_A: {
    killSwitch: 'prosZoneReDesignEnabled',
    experimentRecipeDesktopId: '273-21',
    experimentRecipeMEWId: '277-21',
    isEnabled() {
      const experimentId = Util.isMobile() ?
        FEATURE.PROS_REDESIGN_TREATMENT_A.experimentRecipeMEWId :
        FEATURE.PROS_REDESIGN_TREATMENT_A.experimentRecipeDesktopId;
      return experimentEnabled(FEATURE.PROS_REDESIGN_TREATMENT_A.killSwitch, experimentId);
    },
  },
  PROS_REDESIGN_TREATMENT_B: {
    killSwitch: 'prosZoneReDesignEnabled',
    experimentRecipeDesktopId: '273-22',
    experimentRecipeMEWId: '277-22',
    isEnabled() {
      const experimentId = Util.isMobile() ?
        FEATURE.PROS_REDESIGN_TREATMENT_B.experimentRecipeMEWId :
        FEATURE.PROS_REDESIGN_TREATMENT_B.experimentRecipeDesktopId;
      return experimentEnabled(FEATURE.PROS_REDESIGN_TREATMENT_B.killSwitch, experimentId);
    },
  },
  HP_PROS_CONTENT_TREATMENTS: {
    isEnabled: () => anyExperimentEnabled('prosContentEnabled', ['339-21', '339-22']),
  },
  HP_PROS_COLLECTION_TREATMENTS: {
    isEnabled: () => anyExperimentEnabled('prosCollectionsEnabled', ['339-22', '339-23']),
  },

  BAG_PAGE_RVI_PROS_ZONE_ENABLED: {
    isEnabled: () => experimentEnabled('rviRelatedProsZonesEnabled', '285-21'),
  },
  BAG_PAGE_MULTI_ZONE_C_EXPERIMENT: {
    isEnabled: () => experimentEnabled('bagPageMultiZoneCEnabled', '236-21'),
  },
  HOME_PAGE_PROS_ZONE_E_ENABLED: {
    isEnabled: () => experimentEnabled('homePageProsZoneEEnabled', '419-21'),
  },
};

export default FEATURE;
